<template>
  <div>
    <b-table
      empty-text="Não existe registros para serem apresentados na lista."
      :items="list"
      :fields="fields"
      responsive
      show-empty
      small
      striped
    >
      <template #head(actions)>
        <b-button id="btnAdd" @click.prevent="add()" v-has-permission.permission="['BLO', 'CA']" size="sm" block variant="success">Adicionar</b-button>
      </template>
      <template #cell(actions)="row">
        <b-button :id="'btnEdit' + row.item.id" title="Editar" @click.prevent="edit(row.item.id)" v-has-permission.permission="['BLO', 'AL']" size="sm" variant="warning">
          <i class="fa fa-edit"></i>
        </b-button>

        <b-button :id="'btnDelete' + row.item.id" title="Excluir" @click.prevent="remove(row.item.id, row.index)" v-has-permission.permission="['BLO', 'EX']" size="sm" variant="danger">
          <i class="fa fa-trash-o"></i>
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import BaseRequest from "../../../../request/request";
import { blockPath } from "../../../../router/ApiPaths";
import TabsBase from "./TabsBase.vue";
import { closePopupBus } from "../../../../components/MessageBus";

export default {
  name: "BlockTab",
  mixins: [BaseRequest],
  extends: TabsBase,
  props: ["equipmentId"],

  data() {
    return {
      list: [],
      fields: [],
    };
  },
  mounted() {
    this.type = 36;
    this.path = blockPath;
    this.load();
    this.fields = [
      {
        key: "name",
        label: "Nome",
      },
      {
        key: "floor",
        label: "Quantidade de andares",
      },
      {
        key: "actions",
        label: "Ações",
        class: "text-right width-100",
      },
    ];
  },
  methods: {
   
    exit() {
      closePopupBus();
    },
  },
};
</script>
